import {AttributeMappingCard} from './AttributeMappingEditor'
import type {OutboundConnector} from '@/types/outbound-connector'

interface AttributeMappingCardProps {
    connector: OutboundConnector
    canUpdate: boolean
    onDirtyChange?: (dirty: boolean) => void
}

export function OutboundConnectorAttributeMappingCard({connector, canUpdate, onDirtyChange}: AttributeMappingCardProps) {
    return (
        <AttributeMappingCard
            connectorId={connector.id}
            connectorType={connector.connectorType}
            attributeMappings={connector.attributeMappings}
            canUpdate={canUpdate}
            onDirtyChange={onDirtyChange}
        />
    )
}
